import { createFileRoute, getRouteApi, redirect } from "@tanstack/react-router"
import { Box, Flex, Text } from "@ui"
import type { FC } from "react"

import {
  type SolutionListResponse,
  superpowersFeatureFlagsQuery,
  superpowersSolutionListQuery,
  superpowersSolutionSettingsQuery,
} from "../../-shared/superpowers.query"
import { queryClient } from "../../../../queryClient"
import { FeatureFlags } from "./-components/FeatureFlags"
import { Modules } from "./-components/Modules"
import { SolutionDetails } from "./-components/SolutionDetails"
import { solutionDetailsQuery } from "./-solutionDetails.query"

const routeApi = getRouteApi("/_authenticated/superpowers/$uid/")

const SuperpowersPage: FC = () => {
  const {
    currentSolution,
  }: {
    currentSolution: SolutionListResponse["solutions"][number]
  } = routeApi.useRouteContext()

  return (
    <Flex
      flexDirection="column"
      gap="md"
      overflowY="auto"
      minHeight="none"
    >
      <Flex
        flexDirection="column"
        gap="lg"
      >
        <Text
          fontSize="large"
          textStyle="sectionTitle"
        >
          {currentSolution.name}
        </Text>
        <SolutionDetails solutionUid={currentSolution.solutionUid} />
        <Modules solutionUid={currentSolution.solutionUid} />
        <Box border />
        <FeatureFlags solutionUid={currentSolution.solutionUid} />
      </Flex>
    </Flex>
  )
}

export const Route = createFileRoute("/_authenticated/superpowers/$uid/")({
  beforeLoad: async ({ params }) => {
    const list = await queryClient.ensureQueryData(superpowersSolutionListQuery)
    const currentSolution = list.solutions.find(
      (s) => s.solutionUid === params.uid,
    )

    if (!currentSolution) {
      throw redirect({
        to: "/superpowers/NotFound",
      })
    }

    return { currentSolution }
  },
  loader: async ({ params }) => {
    await Promise.all([
      queryClient.ensureQueryData(solutionDetailsQuery(params.uid)),
      queryClient.ensureQueryData(superpowersSolutionSettingsQuery(params.uid)),
      queryClient.ensureQueryData(superpowersFeatureFlagsQuery(params.uid)),
    ])
  },
  component: SuperpowersPage,
})
